import { render, staticRenderFns } from "./PanelNegocio.vue?vue&type=template&id=e52682d6&"
import script from "./PanelNegocio.vue?vue&type=script&lang=js&"
export * from "./PanelNegocio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports